import DuplicateProject from '@/connection/projects/duplicate-project';
import { serializeError, getPayloadMessage, SerializedError } from '@/store/utils/serialize-error';
import toastTrigger from '@ui/toast/toast-trigger';
import { ProjectsReducerCreator } from '../types';
import { EToastTypes } from '@ui/toast/toast.types';

const duplicateProjectReducer = (create: ProjectsReducerCreator) => {
  return create.asyncThunk(
    async ({ projectUuid, channel }: { projectUuid: string; channel: number }, { rejectWithValue }) => {
      try {
        const result = await DuplicateProject({
          projectUuid,
          channel,
        });
        if ('error' in result) {
          return rejectWithValue(serializeError(result.error));
        }
        const { name, uuid } = result;
        return { name, uuid };
      } catch (e) {
        return rejectWithValue(serializeError(e));
      }
    },
    {
      pending: (state) => {
        state.projectsListLoading = true;
      },
      rejected: (_, action) => {
        console.error('Error duplicating project:', action.error);
        const errMsg =
          getPayloadMessage(action.payload as SerializedError | string | undefined) || action.error?.message;

        toastTrigger('There was an error duplicating the project', {
          type: EToastTypes.error,
          autoClose: 5000,
          description: errMsg,
        });
      },
      settled: (state) => {
        state.projectsListLoading = false;
      },
    }
  );
};

export default duplicateProjectReducer;
